<template>
  <section>
    <template v-if="showSummary">
      <div class="summary" @click.prevent="$emit('open')">
        <slot name="summary" />
      </div>
      <slot name="summary-extra" />
    </template>

    <client-only>
      <Teleport v-if="open" to="#search-wizard-portal">
        <div class="modal" @click.stop="">
          <slot name="body" />
          <footer>
            <base-button
              v-if="showCancelButton"
              css-class="minimal sml"
              @click="$emit('cancel')"
            >
              <translate>Cancel</translate>
            </base-button>
            <base-button
              v-if="showApplyButton"
              data-wizard-submit-button
              data-test="search-wizard-editor-apply"
              css-class="primary asblock wizard-submit-button"
              @click="$emit('apply')"
            >
              <translate>Apply</translate>
            </base-button>
          </footer>
        </div>
      </Teleport>
    </client-only>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['open', 'cancel', 'apply'],
})
class WizardSection extends Vue {
  @Prop({ required: true, type: Boolean })
  open: boolean

  @Prop({ required: true, type: Boolean })
  showSummary: boolean

  @Prop({ required: false, type: Boolean, default: true })
  showApplyButton: boolean

  @Prop({ required: false, type: Boolean, default: true })
  showCancelButton: boolean

  mounted() {
    window.addEventListener('keydown', this.keyPressHandler, { passive: true })
  }

  beforeUnmount() {
    if (this && window && this.keyPressHandler) {
      window.removeEventListener('keydown', this.keyPressHandler)
    }
  }

  escapeKeyHandler() {
    this.$emit('cancel')
  }

  keyPressHandler(event: KeyboardEvent) {
    if (this.open && event.key === 'Escape') {
      this.escapeKeyHandler()
    }
  }
}

export default toNative(WizardSection)
</script>
<style scoped>
section .summary {
  border-radius: 0.65em;
  margin: 1em 0;
  padding: 0.8em 1em;
  box-shadow:
    10px 10px 15px #d9dade,
    -10px -10px 15px #ffffff;
  background: linear-gradient(145deg, #ffffff, #f1f0f4);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

section .summary:active {
  background: #eef0f4;
}

.summary :deep(p) {
  color: var(--colour-dark-blue);
  font-weight: 500;
}

:deep(.location-wizard .summary) {
  padding: 0;
  margin: 0;
  box-shadow: none;
}

:deep(.accommodation-wizard .summary) {
  margin: 0 0 1em 0;
  padding: 0.5em 1em 1em;
}

/* wizard subsection modals */
.modal {
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;
  padding: 1em;
  background: white;
}

footer {
  margin: 1em 0 6em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
